import { useCallback } from "react";
import { DropdownProps } from "semantic-ui-react";

type SelectChangeHandlerProps = {
  handleChange: (arg: { name: string; value: any }) => void;
  hideFormWarning: () => void;
};

const useSelectChangeHandler = ({
  handleChange,
  hideFormWarning,
}: SelectChangeHandlerProps) => {
  return useCallback(
    (event: React.FormEvent<HTMLElement>, data: DropdownProps) => {
      const { name, value } = data;
      handleChange({ name, value });
      hideFormWarning();
    },
    [handleChange, hideFormWarning],
  );
};

export default useSelectChangeHandler;
